<script lang="ts" setup>
withDefaults(
    defineProps<{
        timeout?: number;
    }>(),
    { timeout: 5000 }
);
const isOpen = defineModel<boolean>({ required: true });
</script>

<template>
    <v-snackbar v-model="isOpen" color="error" :timeout="timeout" location="top">
        <slot />
    </v-snackbar>
</template>
